export default __webpack_public_path__ + "static/media/fiat.ffbf0e54.svg";